import AppRestService from './app-rest.service';
import ComingSoonModel from '../models/coming-soon.model';



/**
 * Service Endpoint Implementation
 */
export default class ComingSoonService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'comingSoon';
    this.routePath = 'comingsoon';
    this.idParamName = 'comingsoon_id';
    this.modelClass = ComingSoonModel;
    this.authEnabled = true;
  }

}

